export const common = {
  nav: {
    brandStory: 'Brand Story',
    technology: 'Technology',
    products: 'Products',
    sustainability: 'Sustainability',
    cta: 'Explore Lab',
  },
  brand: {
    name: 'ShanDouDou',
    nameEn: 'foodgogo',
  },
  footer: {
    brandStory: 'Brand Story',
    brandOrigin: 'Origin',
    rdTeam: 'R&D Team',
    brandVision: 'Vision',
    coreTechnology: 'Core Technology',
    freezeDry: 'Freeze Drying',
    microEncapsulation: 'Microencapsulation',
    coldExtraction: 'Cold Extraction',
    productSeries: 'Products',
    functionalGummies: 'Functional Gummies',
    freezeDriedTonics: 'Freeze-Dried Tonics',
    herbalEnergyBars: 'Herbal Energy Bars',
    sustainability: 'Sustainability',
    cleanLabel: 'Clean Label',
    greenSupplyChain: 'Green Supply Chain',
    circularPackaging: 'Circular Packaging',
    contact: 'info@mizean.com',
    copyright: ' 2026 ShanDouDou foodgogo. All rights reserved.',
  },
  langSwitch: {
    zh: '中文',
    en: 'EN',
  },
  notFound: {
    title: 'Page Not Found',
    subtitle: 'This page has not been generated',
    hint: 'Tell me more about this page, so I can generate it',
  },
  misc: {
    scroll: 'SCROLL',
    viewAll: 'View All Products',
    learnMore: 'Learn More',
    viewDetails: 'View Details',
    step: 'Step',
    coreIngredients: 'Key Ingredients',
    suitableFor: 'For: ',
  },
};